// ** Icons Import
import { Link } from "react-router-dom";
import './index.scss'
import { useTranslation } from "react-i18next";

const Footer = () => {

    const { t } = useTranslation();
    const version = process.env.REACT_APP_VERSION;

  return (
    <div className="clearfix mb-0 footer-p">
      <span className="float-md-start d-block d-md-inline-block">
         © {new Date().getFullYear()}{" "} Assistive
        <span className=" d-sm-inline-block">, {t("footer.rights")} </span>
        {version && (
          <span className="footer-version">{t("footer.version")} {version}</span>
        )}
      </span>
      <div className="float-md-end mobile  d-md-block links float-foot-left">
        <ul>
        <li><Link to={"#"}>{t("footer.terms")} </Link>{" "}</li>
        <li><Link to={"#"}>{t("footer.privacy")} </Link>{" "}</li>
        <li><Link to={"#"}>{t("footer.partner")} </Link>{" "}</li>
        <li><Link to={"#"}>{t("footer.help")} </Link></li>
        </ul>
      </div>
    </div>
  );
};

export default Footer;
